<template>
  <div class="bankuaitab" style="min-height: 90vh;">
    <div v-if="bkList.length&&!noData">
      <ul class="plate-wrap">
        <li v-for="(plate, index) in bkList" :key="index">
          <div class="plate-name">{{plate.Name}}<span class="plate-chr" :class="[plate.PxChangeRate > 0 ? 'rise-color': '',plate.PxChangeRate < 0 ?'fall-color' : '']">{{plate.PxChangeRate > 0 ? '+' : ''}}{{plate.PxChangeRate || plate.PxChangeRate == 0 ? plate.PxChangeRate == 0 ? '0.00%' : (plate.PxChangeRate / 100 ).toFixed(2)+ '%' : '--'}}</span></div>
          <ul class="plate-grps" v-if="plate.Grps&&plate.Grps.length">
            <li v-for="(item, gindex) in plate.Grps" :key="gindex" @click="goDetail(item)" style="width:">
              <div>{{item.ProdName}}</div>
              <div class="plate-stock-quote" :class="[item.PxChangeRate > 0 ? 'rise-color': '',item.PxChangeRate < 0 ?'fall-color' : '']">{{item.LastPx ? (item.LastPx / 1000).toFixed(2) : '--'}} {{item.PxChangeRate > 0 ? '+' : ''}}{{item.PxChangeRate || item.PxChangeRate == 0 ? item.PxChangeRate == 0 ? '0.00%' : (item.PxChangeRate / 100 ).toFixed(2)+ '%' : '--'}}</div>
            </li>
            <li class="on-more" @click="onMore(plate.Block, plate.Code)">
              <span>查看更多</span><img src="../../../assets/icons/icon_more.png" alt=""></li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="no-content" v-if="noData">
      <img src="../../../assets/no_data.png" alt="">
    </div>
  </div>
</template>

<script>
import {request} from '@/api/request'
import {mapState} from 'vuex'
export default {
  data () {
    return {
      bkList: [],
      noData: false
    }
  },
  computed: {
    ...mapState(['symbol', 'market'])
  },
  created () {
    this.getPlateLists()
  },
  methods: {
    goDetail(item) {
      this.$router.push(`/${item.HqTypeCode.toLowerCase()}/${item.ProdCode}.html`)
      window.location.reload()
    },
    async getPlateLists () {
      const url = request.apis.quote.plateTop3Lists
      const res = await request.get({
        url,
        params: {
          stockcode: `${this.symbol}.${this.market.toUpperCase()}`
        }
      })
      if (res&&res.length) {
        this.bkList = res
      } else {
        this.noData = true
      }
    },
    onMore(block, code) {
      this.$router.push(`/plateConstituentStock/${block}/${code}.html`)
    }
  }
}
</script>

<style lang="stylus" scoped>
.no-content
  display flex
  flex-direction column
  align-items center
  margin 20px
  img
    width 50%
.plate-wrap > li
  padding 12px
  border-bottom 1px solid #EBEBEB
.plate-name
  font-size 16px
  font-weight bold
.plate-grps
  display flex
  margin-top 8px
  justify-content: space-between
  li
    background #F5F5F5
    font-size 14px
    padding 8px 0
    height 59px
    display flex
    flex-direction column
    align-items center
    justify-content center
    width 120px
  .on-more
    background white
    border 1px solid #F0F0F0
    display flex
    flex-direction row
    width 91px
    img
     width 6px
     height 11px
.plate-chr
  font-size 18px
  margin-left 8px

.plate-stock-quote
  font-weight bold
  font-size 14px
  text-align center
span
  display inline-block
</style>